export default __webpack_public_path__ + "static/media/regulatory--no-motor-vehicles--g5.d88792f9.png";